import React from 'react'

import SectionContent from '../../components/SectionContent'
import SectionHeader from '../../components/SectionHeader'
import SectionLayout from '../../components/SectionLayout'
import SingleCurriculum from '../../components/SingleCurriculum'
import { CurriculumSectionData } from '../../data/curriculumSection'

const CurriculumSection = (props: { type?: string }) => {
  const { type = 'dsa' } = props
  return (
    <SectionLayout>
      <SectionHeader>
        <span className="text-primary">Program</span> Curriculum
      </SectionHeader>
      <SectionContent>
        <SingleCurriculum data={CurriculumSectionData[type]} />
      </SectionContent>
    </SectionLayout>
  )
}

export default CurriculumSection
